// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3yBVo","content":"LayoutSettings_content__If7QA"};